export const CertaintyLevelConstants = {
  // Route Tokens
  defaultApi: 'CertaintyLevel',

//  APPLICATION: "application",
//  GROUP: "group",
//  OLDER_THAN: "olderThan",
//  ROLES: "roles",

  // Other constants
    UI: {
    ROOT_PATH: 'certainty-level',
  }

} as const;
